/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Box, FlexContainer, theme } from "@nordcloud/gnui";

import { Option, SearchBoxContainer, SortDirection } from "~/components";
import { SELECT_OPTIONS } from "../constants";
import { SortByOrder, SortByValue } from "../types";
import { SettingsSort } from "./SettingsSort";

type Props = {
  searchInput: string;
  width?: string;
  sortField: string;
  sortDirection: SortByOrder;
  sortOptions?: Option[];
  onSortSelect: (value: SortByValue) => void;
  onSortOrderChange: (value: SortDirection) => void;
  setSearchInput: (input: string) => void;
};

export function SearchSortContainer({
  searchInput,
  sortField,
  sortDirection,
  sortOptions = SELECT_OPTIONS,
  onSortSelect,
  onSortOrderChange,
  setSearchInput,
}: Props) {
  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <FlexContainer justifyContent="space-between" alignItems="center">
        <SettingsSort
          sortField={sortField}
          sortDirection={sortDirection}
          options={sortOptions}
          onSortSelect={onSortSelect}
          onSortOrderChange={onSortOrderChange}
        />
        <div
          css={{
            marginInline: theme.spacing.spacing05,
            flexGrow: 1,
          }}
        >
          <SearchBoxContainer
            searchInput={searchInput}
            setSearchInput={setSearchInput}
          />
        </div>
      </FlexContainer>
    </Box>
  );
}
